import React from 'react'
import { Box, TextField, Typography, FormControl, InputLabel, Select, MenuItem,Button, Stack } from '@mui/material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
import TypographyProps from './common/TypographyProps';
import BlockProps from './common/BlockProps';

function HeaderBlockProperties({blockId}) {
 const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };

  
  return (
   <>
            <TextField
              fullWidth
              label="Header Text"
              value={properties.title || ''}
              onChange={(e) => handlePropertyChange('title', e.target.value)}
              sx={{ mb: 2 }}
            />
            <Box sx={{mb:2}}>
              <Typography variant="body2" gutterBottom>
                    Header Level
              </Typography>
               <Stack direction="row" spacing={2}>
                  <Button 
                      variant={properties.level === 'h1' ? 'contained' : 'outlined'}
                      onClick={(e) => handlePropertyChange('level', 'h1')} 
                    >
                      H1</Button>
                   <Button 
                      variant={properties.level === 'h2' ? 'contained' : 'outlined'}
                      onClick={(e) => handlePropertyChange('level', 'h2')} 
                    >
                      H2</Button>
                    <Button 
                      variant={properties.level === 'h3' ? 'contained' : 'outlined'}
                      onClick={(e) => handlePropertyChange('level', 'h3')} 
                    >
                      H3</Button>
                     <Button 
                      variant={properties.level === 'h4' ? 'contained' : 'outlined'}
                      onClick={(e) => handlePropertyChange('level', 'h4')} 
                    >
                      H4</Button>
                  </Stack>
            </Box>
            
          <TypographyProps properties={properties} onPropertyChange={handlePropertyChange} />
          <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />
           
          </>
  )
}

export default HeaderBlockProperties